import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../data";
import { SectionHeading } from "./SectionHeading";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative z-10 py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Testimonials"
          title="Trusted by Bay Area car owners"
          subtitle="From daily drivers to exotics — here's what our clients say about the Marez experience."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
              className="relative rounded-2xl border border-white/5 bg-[#111111] p-8 hover:border-white/20 transition-colors duration-300"
            >
              <Quote size={30} className="text-white/15 mb-5" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={15} className="fill-white text-white" />
                ))}
              </div>
              <p data-testid={`testimonial-quote-${i}`} className="text-base text-zinc-200 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <p data-testid={`testimonial-name-${i}`} className="font-heading font-semibold text-white">{t.name}</p>
                <p data-testid={`testimonial-source-${i}`} className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 mt-1">
                  {t.car}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
